// extracted by mini-css-extract-plugin
export default {"loading":"spinner_loading__Ffx6Z","spin":"spinner_spin__f6-y6","simple_loading":"spinner_simple_loading__BIL+W","pulse":"spinner_pulse__QGQ1Z"};